export const MENSAGENS_ERRO = [
  {
    semPermissaoPadrao: "Usuário sem permissão para realizar esta ação",
    opeCredNaoEncontrada: "Operação Garantida não encontrada",
    rcNaoEncontrada: "Recuperação de Crédito não encontrada",
    solHonraNaoEncontrada: "Solicitação de Honra não encontrada",
    infoNaoEncontrada: "Informação não encontrada",
    semPermissaoLote: "Não foi possível enviar o lote, modalidade inválida"
  }
];